import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
export function renderOptions(params) {
  var _ref;

  var option = {
    color: ['#3398DB'],
    tooltip: {
      trigger: 'axis',
      formatter: params.tipsformatter,
      // '{b}<br/>{a}:{c}' + '台',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '0%',
      top: '8%',
      containLabel: true
    },
    xAxis: [(_ref = {
      type: 'category',
      axisTick: {
        show: false
      },
      data: params.xAxis
    }, _defineProperty(_ref, "axisTick", {
      alignWithLabel: true
    }), _defineProperty(_ref, "axisLabel", {
      color: '#fff'
    }), _ref)],
    yAxis: [{
      type: 'value',
      interval: 1,
      axisLabel: {
        color: '#fff'
      },
      splitLine: {
        show: false
      }
    }],
    series: params.series
  };
  return option;
}